module.exports = __webpack_public_path__ + "img/submitted-reimbursements.e4f13b27.svg";